import React, { useEffect, useState } from "react";

import ViewAppBar from "../views/ViewAppBar";

import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";
import HeroSection from "../views/HeroSection";
import ViewVender from "../views/ViewVender";
import FormSection from "../views/FormSection";
import ViewProvaSocial from "../views/ViewProvaSocial";
import ViewDivulgacao from "../views/ViewDivulgacao";
import ViewTroca from "../views/ViewTroca";
import { useLocation } from "react-router-dom";
import Globais, { validateToken } from "../components/Globais";
import AtendimentoCard from "../components/AtendimentoCard";
import "@fortawesome/fontawesome-free/css/all.min.css";

const Inicio: React.FC = () => {
  const location = useLocation();
 const [Adm, setAdm] = useState<boolean | null>(null);
  const [isAdministrador, setIsAdministrador] = useState(false);
  const [loading, setLoading] = useState(true);

  
useEffect(() => {
  const checkToken = async () => {
    try {
      const Token = await validateToken(); // ✅ espera o retorno

      if (!Token) {
        window.location.href = Globais.DOMINIOFRONT + "/login";
        return;
      }

      console.log("Token recebido:", Token); // debug
      setAdm(Token.nda === 1 || Token.nda === 2);
      setIsAdministrador(Token.nda === 1);
    } catch (error) {
      console.error("Erro ao validar token:", error);
      window.location.href = Globais.DOMINIOFRONT + "/login";
    } finally {
      setLoading(false);
    }
  };

  checkToken();
}, []);

 
  const handleLogout = () => {
    // 2. Se estiver usando localStorage/sessionStorage:
    localStorage.clear();
    sessionStorage.clear();

    // 3. Redirecionar para a página principal
    window.location.href = "/login";
  };

  if (loading || Adm === null) {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gradient-to-b from-[#003644] to-[#005b70] text-white">
      <div className="animate-bounce">
  <img src="/logo-multicotas.png" alt="Multicotas" className="w-32 h-auto" />
</div>
<p className="mt-4 text-lg text-white animate-pulse">
  Preparando sua experiência...
</p>
    </div>
  );
}

  return (
    <>
      <ContatoZap />

      <div>
        <ViewAppBar />
        <p className="descubra-texto">
          Role para baixo e descubra tudo o que a Multicotas pode te oferecer
        </p>
        <div className="scroll-hint">
          <i className="fas fa-chevron-down"></i>
        </div>
        {Adm ? (
          <main className="card-grid">
            {isAdministrador && <AtendimentoCard />}
            {/* // Configurações */}
            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-gear"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Configurações</h2>
              <p>
                Edição de configurações de apartamentos, cotas e
                empreendimentos.
              </p>
              <a href={Globais.DOMINIOFRONT + "/gerenciar"}>
                Inserir Informações
              </a>
            </div>
            {/* // gerenciar usuários */}
            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-user-gear"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Gerenciar Usuários</h2>
              <p>Visualize as informações dos usuários.</p>
              <a href={Globais.DOMINIOFRONT + "/gerenciarusuarios"}>Usuários</a>
            </div>
            {/* //Gerenciar Compatibilidades */}
            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-sliders"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Gerenciar Compatibilidades</h2>
              <p>
                Verifique as compatilidades entre interessados e
                disponibilizados.
              </p>
              <a href={Globais.DOMINIOFRONT + "/gerenciarCompatibilidades"}>
                Compatibilidades
              </a>
            </div>
            {/* //Solicitações de Reserva */}
<div className="card">
  <div style={{ textAlign: "center" }}>
    <i
      className="fas fa-file-circle-check"
      style={{
        fontSize: "2rem",
        marginBottom: "1rem",
        color: "#003644",
      }}
    ></i>
  </div>
  <h2>Solicitações de Reserva</h2>
  <p>
    Visualize, filtre e acompanhe as solicitações de reserva enviadas pelos
    clientes.
  </p>
  <a href={Globais.DOMINIOFRONT + "/gerenciar-solicitacoes-reserva"}>
    Gerenciar
  </a>
</div>
            {/* //Disponível para Alugar */}
            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-door-open"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Disponível para Alugar</h2>
              <p>Gerencie períodos que estejam disponíveis, aptos a alugar.</p>
              <a
                href={
                  Globais.DOMINIOFRONT +
                  "/gerenciarperiodosusuarios/?cotaUsuarioId=0"
                }
              >
                Gerenciar
              </a>
            </div>
            {/* //Gerenciar Propriedades */}
            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-house"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Gerenciar Propriedades</h2>
              <p>Gerencie as propriedades cadastradas no sistema.</p>
              <a
                href={Globais.DOMINIOFRONT + "/gerenciarPropriedades?userId=0"}
              >
                Gerenciar
              </a>
            </div>
            {/* //Dashboard */}
            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-chart-line"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Dashboard</h2>
              <p>Visualize o dashboard.</p>
              <a href={Globais.DOMINIOFRONT + "/dashboard"}>Gerenciar</a>
            </div>
            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-triangle-exclamation"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Operacional</h2>
              <p>
                Acompanhe o dashboard operacional e identifique CTU que exigem
                atenção.
              </p>
              <a href={Globais.DOMINIOFRONT + "/dashboardOperacional"}>
                Acessar
              </a>
            </div>
            {/* //Reservas */}
            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-calendar-check"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Reservas</h2>
              <p>Visualize as reservas.</p>
              <a href={Globais.DOMINIOFRONT + "/listarReservas"}>Gerenciar</a>
            </div>
            {/* //Marketing */}
            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-bullhorn"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Marketing</h2>
              <p>Gerencie campanhas, leads, etiquetas e postagens do sistema.</p>
              <a href={Globais.DOMINIOFRONT + "/marketing"}>Acessar</a>
            </div>                   
            {/* //Gerencie as Indicações */}
            <div className="card">
                <div style={{ textAlign: 'center' }}>
              <i className="fas fa-handshake" style={{ fontSize: "2rem", marginBottom: "1rem", color: "#003644" }}></i>
              </div>
              <h2>Gerencie as Indicações</h2>
              <p>Visualize Indicações.</p>
              <a href={Globais.DOMINIOFRONT+"/gerenciarIndicacoesParceiros"}>Gerenciar</a>
              </div>
            {/* //Gerencie Assinaturas */}
              <div className="card">
                <div style={{ textAlign: 'center' }}>
              <i className="fas fa-file-signature text-primary" style={{ fontSize: "2rem", marginBottom: "1rem", color: "#003644" }}></i>
              </div>
              <h2>Gerencie assinaturas</h2>
              <p>Visualize as assinaturas de anúncio de venda.</p>
              <a href={Globais.DOMINIOFRONT+"/gerenciarAssinatura"}>Gerenciar</a>
              </div>
            {/* // Sair */}
            {/* //Gerenciar Anúncios */}
<div className="card">
  <div style={{ textAlign: "center" }}>
    <i
      className="fas fa-bullseye"
      style={{
        fontSize: "2rem",
        marginBottom: "1rem",
        color: "#003644",
      }}
    ></i>
  </div>
  <h2>Gerenciar Anúncios</h2>
  <p>Visualize e gerencie os anúncios cadastrados no sistema.</p>
  <a href={Globais.DOMINIOFRONT + "/gerenciarAnuncios"}>Gerenciar</a>
</div>

            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-sign-out-alt"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Sair</h2>
              <p>Encerrar sessão e voltar para a página principal.</p>
              <button
                onClick={handleLogout}
                style={{
                  padding: "10px 40px",
                  fontSize: "14px",
                  backgroundColor: "#003644",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  marginTop: "10px",
                  width: "fit-content", // faz o botão ficar do tamanho do conteúdo
                  alignSelf: "center", // centraliza horizontalmente se o container for flex
                  display: "block",
                }}
              >
                Sair
              </button>
            </div>
          </main>
        ) : (
          <main className="card-grid">
            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-hand-holding-usd"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Minhas propriedades</h2>
              <p>
                Visualize suas propriedades, nelas seus períodos e outras
                informações.
              </p>
              <a href={Globais.DOMINIOFRONT + "/cadastroCotas"}>
                Ver minhas propriedades
              </a>
            </div>
            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-tags"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Meus interesses</h2>
              <p>
                Indique para a Multicotas onde gostaria de fazer sua próxima
                viagem e encontre grandes oportunidades.
              </p>
              <a href={Globais.DOMINIOFRONT + "/interesses"}>Meus interesses</a>
            </div>
            <div className="card">
  <div style={{ textAlign: "center" }}>
    <i
      className="fas fa-id-card"
      style={{
        fontSize: "2rem",
        marginBottom: "1rem",
        color: "#003644",
      }}
    ></i>
  </div>
  <h2>Meus Dados Pessoais</h2>
  <p>
    Consulte e atualize suas informações pessoais, como nome, telefone e
    e-mail.
  </p>
  <a href={Globais.DOMINIOFRONT + "/dadospessoais"}>Acessar</a>
</div>


            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-bed"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Reservar Hospedagem</h2>
              <p>
                Quer viajar e deseja encontrar hospedagens com preços atrativos
                nos principais hotéis do Brasil? Reserve aqui.
              </p>
              <a href="https://www.reservas.multicotas.com.br/">
                Fazer Reserva
              </a>
            </div>

            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-gavel"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Dúvidas Jurídicas</h2>
              <p>
                Saiba seus direitos e consulte apoio jurídico com nossos
                escritórios parceiros.
              </p>
              <a href="https://wa.me/5521972737678?text=Olá%20gostaria%20de%20saber%20mais%20sobre%20apoio%20juridico%20!jud!%20">
                Acessar Orientações
              </a>
            </div>

            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-comments"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Entre em Contato</h2>
              <p>
                Fale com nossa equipe para esclarecer dúvidas ou solicitar
                ajuda.
              </p>
              <a href="https://wa.me/5521972737678?text=Olá%20Multicotas%20tenho%20algumas%20dúvidas%20/?%20">
                Fale Conosco
              </a>
            </div>
          
     

            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-sign-out-alt"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Sair</h2>
              <p>Encerrar sessão e voltar para a página principal.</p>
              <button
                onClick={handleLogout}
                style={{
                  padding: "10px 40px",
                  fontSize: "14px",
                  backgroundColor: "#003644",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  marginTop: "10px",
                  width: "fit-content", // faz o botão ficar do tamanho do conteúdo
                  alignSelf: "center", // centraliza horizontalmente se o container for flex
                  display: "block",
                }}
              >
                Sair
              </button>
            </div>
          </main>
        )}

        <ViewFooter />
      </div>
    </>
  );
};



  
  

export default Inicio;
